import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSettings(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/settings')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchPublicSettings(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/settings/public')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateSettings(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/settings/update`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    },
}